module.exports = {
      id: "newlogo_L1-usage",
      viewBox: "0 0 60 34",
      url: __webpack_public_path__ + "svg-sprite-39ec39c5b3d32c0adb9732979a5c9627.svg#newlogo_L1",
      toString: function () {
        return this.url;
      }
    }